import React, { useState, useEffect } from 'react';
import QueryString from 'query-string';

import PageTitle from '../PageTitle/page_title';
import AssetDetailReportForm from './asset_detail_report_form';
import AssetDetailReportGraphs from "./asset_detail_report_graph";
import AssetDetailReportAlerts from './asset_detail_report_alerts';
import i18next from "i18next";

const AssetDetailReport = ({location}) => {
  const [fromPrint, setFromPrint] = useState(false);
  const [query, setQuery] = useState(null);
  const [charts, setCharts] = useState(null);
  const [printing, setPrinting] = useState(false);
  const [chartsLoaded, setChartsLoaded] = useState(false);

  useEffect(() => {
    const urlSearch = QueryString.parse(location.search);
    setFromPrint(urlSearch["print"] === "true");

    if (urlSearch["print"] === "true") {
      setQuery(JSON.parse(localStorage.getItem("query")));
      localStorage.removeItem("query");

      setCharts(JSON.parse(localStorage.getItem("charts")));
      localStorage.removeItem("charts");
    }
  }, [location]);

  const printClicked = () => {
    localStorage.setItem('query', JSON.stringify(query));
    window.open(`${window.location.href}?stripnav=true&print=true`, '_blank') // to open new page
  }

  const alertsFetched = () => {
    if (fromPrint && !printing) {
      setPrinting(true);
      window.print();
    }
  };

  const graphFetched = (charts) => {
    localStorage.setItem("charts", JSON.stringify(charts));
    setChartsLoaded(true);
  };

  return (
      <div className="animated fadeIn">
        <div className="row">
          <PageTitle title={ i18next.t('pages.asset-detail-report.header')} />
        </div>
        <div className="device-detail-report">
          <div className="col-sm-12">
              <AssetDetailReportForm
                  onSubmit={(deviceReportData) => setQuery(deviceReportData)}
                  initData={query}
                  disableDeviceSelection={fromPrint}
                  showPrintButton={!fromPrint && query && chartsLoaded}
                  printClicked={printClicked}
                  groupingSelected={() => setQuery(null)}
              />
          </div>
        </div>
        {query &&
            <div className = "device-detail-report col-sm-12">
              <AssetDetailReportGraphs query={query} initCharts={charts} dataFetched={graphFetched} initHideExport={fromPrint || !query || !chartsLoaded} />
              {chartsLoaded && <AssetDetailReportAlerts query={query} dataFetched={alertsFetched} /> }
            </div>
        }
      </div>
  );
}

export default AssetDetailReport;
